import React, {useState} from 'react';
import {registerUser} from '../api';
import {Link, useNavigate} from 'react-router-dom';
import './Auth.css';

function RegisterPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (event) => {
        event.preventDefault();
        setErrorMsg('');
        setSuccessMsg('');
        const res = await registerUser(username, password);

        if (res.message === 'Registration successful') {
            setSuccessMsg('Регистрация успешна. Сейчас вы будете перенаправлены к логину.');
            setTimeout(() => navigate('/login'), 1000);
        } else {
            setErrorMsg(res.message || 'Ошибка регистрации');
        }
    };

    return (
        <section className="auth-page">
            <div className="auth-card panel">
                <p className="page-kicker">Новый аккаунт</p>
                <h1>Регистрация</h1>

                <form className="auth-form" onSubmit={handleRegister}>
                    <div className="field">
                        <label htmlFor="register-username">Имя пользователя</label>
                        <input
                            id="register-username"
                            type="text"
                            autoComplete="username"
                            placeholder="Придумайте логин"
                            value={username}
                            onChange={event => setUsername(event.target.value)}
                        />
                    </div>

                    <div className="field">
                        <label htmlFor="register-password">Пароль</label>
                        <input
                            id="register-password"
                            type="password"
                            autoComplete="new-password"
                            placeholder="Придумайте пароль"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                        />
                    </div>

                    {errorMsg && <div className="notice notice-error auth-message">{errorMsg}</div>}
                    {successMsg && <div className="notice notice-success auth-message">{successMsg}</div>}

                    <button className="btn btn-primary auth-btn" type="submit">
                        Зарегистрироваться
                    </button>
                </form>

                <div className="switch-auth">
                    <span>Уже есть аккаунт?</span>
                    <Link to="/login">Войти</Link>
                </div>
            </div>

            <aside className="auth-showcase" aria-label="Популярные товары">
                <div className="auth-product auth-product-main">
                    <img src="/images/iphone15white.png" alt="Iphone15 White" />
                    <strong>Iphone15</strong>
                    <span>от 99 999 руб.</span>
                </div>
                <div className="auth-product-row">
                    <div className="auth-product">
                        <img src="/images/samsung.png" alt="Galaxy Ultra 24" />
                        <strong>Galaxy Ultra 24</strong>
                    </div>
                    <div className="auth-product">
                        <img src="/images/xiaomi14.png" alt="Xiaomi 14" />
                        <strong>Xiaomi 14</strong>
                    </div>
                </div>
            </aside>
        </section>
    );
}

export default RegisterPage;
